var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pl-0 pr-0 pt-0 pb-0" },
    [
      _vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "gpcSessionGroup",
                    breakpoint: "md",
                    label: "GPC Session",
                    "label-for": "gpcselect",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.sessions,
                      id: "gpcselect",
                      required: _vm.required
                    },
                    on: {
                      input: function($event) {
                        _vm.selectionMade($event)
                      }
                    },
                    model: {
                      value: _vm.session,
                      callback: function($$v) {
                        _vm.session = $$v
                      },
                      expression: "session"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-190ebb60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190ebb60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GPCSessionSelection.vue
// module id = null
// module chunks = 